















































































































import Vue from 'vue';
import {
  Component,
  Prop,
  Emit,
  Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store'
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import JustifyModal from '@/shared/modal/justify-modal.component.vue';
import IconInfoDescription from '@/shared/icons/icon-info-description.component.vue';
import ContractRule from '@/domain/contract/entity/contract-rule.entity';
import Rule from '@/domain/rule/entity/rule.entity';
import RuleService from '@/domain/rule/service/rule.service';
import Rules from '@/shared/rules/rules';
import { JustifyType } from '@/domain/justify/domain/justify-type.enum';
import ContractService from '@/domain/contract/service/contract.service';
import JustifyPersist from '@/domain/justify/domain/justify-persist.entity';
import EventBus, { Event } from '@/event.bus';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import UserProfile from '@/domain/access/domain/profile.enum';

@Component({
  components: {
    JustifyModal, ModalWarning, VbTooltipSlot, IconInfoDescription,
  },
})
export default class ManageCalculationEdition extends Vue {
  @Prop() contractRules!: ContractRule[];

  @Prop() editMode!: boolean;

  @Prop() isAdministrator!: boolean;

  @Prop() restrictRules!: any;

  @Prop() profile!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  isProductTemplate!: boolean;

  warningModal: boolean = false;

  warningMessage: string = 'Deseja realmente ativar essa regra?'
        + 'Ao clicar no botão Sim, as alterações serão imediatamente realizadas.';

  rules: Rule[] = [];

  readonly: boolean = false;

  newContractRules: ContractRule[] = [];

  validationRules: Rules = new Rules();

  justifyType: JustifyType = JustifyType.CONTRACT_RULE_DISABLE;

  showJustityModal: boolean = false;

  businessUnitId;

  selectedRuleId: string = '';

  get disablePlayButton(): boolean {
    return this.contractRules[0].id !== '';
  }

  created() {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && this.$route.name.includes('Contrato')) {
        this.businessUnitId = businessUnit.id;
      }
    })
    this.getRules();
    this.newContractRules = this.contractRules;
  }

  confirm() {
    this.enableRule();
  }

  showJustifyModalAndSetRule(ruleId: string) {
    this.selectedRuleId = ruleId;
    this.showJustityModal = true;
  }

  @Watch('contractRules')
  watchRules() {
    Object.assign(this.newContractRules, this.contractRules);
    this.$forceUpdate()
  }

  updateJustifyModalVisibility(value: boolean) {
    this.showJustityModal = value;
  }

  getRules() {
    RuleService.getRules()
      .then((response: Rule[]) => this.rules = response)
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  updateRules(contractRule: Rule, index: number) {
    this.newContractRules.splice(index, 1, ContractRule.ofEnabled(contractRule));
    this.update();
  }

  clearRule(index: number) {
    this.newContractRules.splice(index, 1, ContractRule.of({}));
    this.update();
  }

  addNewRule() {
    this.newContractRules.push(ContractRule.ofEnabled({}));
  }

  removeRule(index: number) {
    this.newContractRules.splice(index, 1);
    this.update();
  }

  get editColor(): string {
    return this.newContractRules.length > 1
      ? 'red' : 'lightGray';
  }

  get isGPProfile() {
    return this.profile === UserProfile.GP;
  }

  hasPermissionEdit(ruleId: string): boolean {
    if (this.isGPProfile) {
      return (!this.checkExistsRestrictRules() && !this.checkRuleRestrict(ruleId));
    }
    return !this.isAdministrator
  }

  @Emit('update')
  update() {
    return this.newContractRules;
  }

  persistJustify(values) {
    const justify: JustifyPersist = values.justify;
    ContractService.disableContractItemRule(this.businessUnitId,
      this.$route.params.id, this.selectedRuleId, justify)
      .then(() => {
        this.showJustityModal = false;
        VbSnackbarService.showSuccess('Regra de cálculo desativada com sucesso')
        this.disableRuleStatus(justify);
        this.selectedRuleId = '';
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
  }

  enableRule() {
    ContractService.enableContractItemRule(this.businessUnitId,
      this.$route.params.id, this.selectedRuleId)
      .then(() => {
        this.warningModal = false;
        VbSnackbarService.showSuccess('Regra de cálculo ativada com sucesso')
        this.updateRuleStatus(true);
        this.selectedRuleId = '';
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
  }

  updateRuleStatus(value: boolean) {
    const rule = this.contractRules.find((el: ContractRule) => el.id === this.selectedRuleId);
    if (rule) {
      rule.status.enabled = value
    }
  }

  disableRuleStatus(justify: JustifyPersist) {
    const rule = this.contractRules.find((el: ContractRule) => el.id === this.selectedRuleId);
    if (rule) {
      rule.disable(justify);
    }
  }

  checkRuleRestrict(ruleId: string): boolean {
    const ruleRestrictExists = this.restrictRules.find((el) => el.id === ruleId);
    if (ruleRestrictExists) return true;
    return false;
  }

  checkDisabledField(ruleId: string): boolean {
    return (!this.isAdministrator) || this.checkReadOnlyField(ruleId);
  }

  checkReadOnlyField(ruleId: string): boolean {
    return this.restrictRules.length > 0 && !this.checkRuleRestrict(ruleId);
  }

  filterRuleWithOnlyRestrict(): Rule[] {
    if (this.restrictRules.length > 0) {
      return this.restrictRules;
    }
    return this.rules;
  }

  checkExistsRestrictRules(): boolean {
    return (this.restrictRules.length > 0);
  }

  checkReadOnlyFieldEditMode(ruleId: string): boolean {
    if (this.editMode) {
      return (this.checkExistsRestrictRules() && !this.checkRuleRestrict(ruleId));
    }
    return !this.editMode;
  }
}
